import Order from "features/order/containers/Order";
import React from "react";

const OrderComponent = () => {
  return <Order />;
};

export default OrderComponent;
